module.exports = __webpack_public_path__ + "static/media/konsultng.0a7a485b.svg";